import React, {useRef, useState} from "react"

const loadStateFromSessionStorage = (sessionStorageKey, defaultValue) => {
    if (sessionStorageKey) {
        const value = sessionStorage.getItem(sessionStorageKey)
        return value ? JSON.parse(value) : defaultValue
    }
    return defaultValue
}

export const saveStateToSessionStorage = (sessionStorageKey, value) => {
    sessionStorage.setItem(sessionStorageKey, JSON.stringify(value))
}

export const useRefState = (initValue, sessionStorageKey = null) => {
    const [state, _setState] = useState(() => loadStateFromSessionStorage(sessionStorageKey, initValue))
    const ref = useRef(state)
    
    const getCurrent = () => {
        return ref.current
    }

    const addState = (state) => {
        setState({...getCurrent(), ...state})
    }

    const setState = (state) => {
        ref.current = state
        _setState(state)
        if(sessionStorageKey) {
            saveStateToSessionStorage(sessionStorageKey, ref.current)
        }
    }

    return {state, setState, addState, getCurrent}
}

